import { useState } from 'react';
import {
  Box,
  Heading,
  Stack,
  Text,
} from '@chakra-ui/react';
import { DedupListingCard } from 'components';
import PaginationFooter from 'components/Pagination/PaginationFooter/PaginationFooter';
import EmptyState from 'components/EmptyState/EmptyState';
import { useApproveDedupListing, useDedupListings, useRejectDedupListing } from 'hooks/queries/useDedup';

export default function DedupListingOverviewView() {
  const [page, setPage] = useState(1);
  const [actionId, setActionId] = useState<string | null>(null);
  const { data: paginatedDedupListings, isLoading } = useDedupListings(page);
  const approveMutation = useApproveDedupListing();
  const rejectMutation = useRejectDedupListing();

  const listings = paginatedDedupListings?.data || [];
  const totalPages = paginatedDedupListings?.totalPages || 0;

  const handleApprove = (id: string) => {
    setActionId(id);
    approveMutation.mutate(id, { onSettled: () => setActionId(null) });
  };

  const handleReject = (id: string) => {
    setActionId(id);
    rejectMutation.mutate(id, { onSettled: () => setActionId(null) });
  };

  const isEmpty = !isLoading && listings.length === 0;

  return (
		<Box maxWidth="1200px" width="100%" paddingTop={['80px', '100px', '100px']} justifySelf="center" minHeight="100vh">
      <Heading size="md" mb={6}>Dedup Listings</Heading>
      {isLoading ? (
        <Text color="gray.500" fontSize="sm">Loading dedup listings...</Text>
      ) : isEmpty ? (
        <EmptyState header="No Dedup Listings" description="There are no deduplicated listings awaiting review." showButton={false} />
      ) : (
        <Stack spacing={4}>
          {listings.map((dedupListing) => (
            <DedupListingCard
              key={dedupListing.id}
              dedupListing={dedupListing}
              onApprove={handleApprove}
              onReject={handleReject}
              isApproving={approveMutation.isPending && actionId === dedupListing.id}
              isRejecting={rejectMutation.isPending && actionId === dedupListing.id}
            />
          ))}
        </Stack>
      )}
      {totalPages > 1 && (
        <PaginationFooter
          currentPage={page}
          lastPage={totalPages}
          siblingsCount={1}
          onPageChange={setPage}
        />
      )}
    </Box>
  );
}
